/*
  Arrows for the product card colour-swatch row.

  A card is ~148px wide on a phone, so a ten-colour group only ever shows four
  swatches. The row scrolls, but nothing said so — the rest just looked cut off.

  The arrows sit beside the row, never on top of it: an earlier version overlaid
  them on the end swatches, which stole the tap meant for that colour.

  On touch devices the arrows are hidden by CSS and a fade on the trailing edge
  hints at the overflow instead — swiping is the native gesture there, and a
  22px target inside a 148px card is a mis-tap waiting to happen. The classes
  set here drive that fade, so they are kept up to date on every device.

  Guarded by a global flag: the loader snippet can end up in the page more than
  once, and a second execution would bind every handler twice.
*/
(function () {
  if (window.__muvaSwatchSlider) return;
  window.__muvaSwatchSlider = true;

  var READY_ATTR = 'data-muva-swatch-ready';

  function update(slider) {
    var track = slider.querySelector('[data-muva-swatch-track]');
    if (!track) return;

    var prev = slider.querySelector('.muva-swatch-nav--prev');
    var next = slider.querySelector('.muva-swatch-nav--next');
    var overflow = track.scrollWidth - track.clientWidth;
    var moreBefore = overflow > 1 && track.scrollLeft > 1;
    var moreAfter = overflow > 1 && track.scrollLeft < overflow - 1;

    if (prev) prev.hidden = !moreBefore;
    if (next) next.hidden = !moreAfter;

    slider.classList.toggle('muva-swatch-slider--more-before', moreBefore);
    slider.classList.toggle('muva-swatch-slider--more-after', moreAfter);
  }

  function setup(slider) {
    if (slider.hasAttribute(READY_ATTR)) return;
    slider.setAttribute(READY_ATTR, '');

    var track = slider.querySelector('[data-muva-swatch-track]');
    if (!track) return;

    slider.addEventListener('click', function (event) {
      var button = event.target.closest('.muva-swatch-nav');
      if (!button) return;

      /* The whole card is a tap target (muva-card-tap), so the click must not
         reach it or the arrow would navigate to the product. */
      event.preventDefault();
      event.stopPropagation();

      var step = Math.max(track.clientWidth - 42, 42);
      var direction = button.classList.contains('muva-swatch-nav--prev') ? -1 : 1;
      track.scrollBy({ left: step * direction, behavior: 'smooth' });
    });

    track.addEventListener('scroll', function () { update(slider); }, { passive: true });

    if (window.ResizeObserver) {
      new ResizeObserver(function () { update(slider); }).observe(track);
    }

    update(slider);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.muva-swatch-slider').forEach(setup);
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    scan();

    /* Cards also arrive after load-more, infinite scroll and quick view. */
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        scan();
      });
    }).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', function (event) {
      scan(event.target);
    });
  });
})();